import { useContext } from 'react';
import { LoanVehicleContext } from './loanVehicle-provider';
import { InputLabel, Grid, FormHelperText, Hidden } from '@material-ui/core';
import { TextBox, DateTimePicker, YesNoButton, SingelSelect } from '../../../Core/FormInput';
import { Alert } from '@material-ui/lab';
import { BiggerDisabledText } from '../../../Core/FormInput/AppTextBox';

const BookingDetails = () => {
    const { bookingDetails, handleBookingDetails, handleYesNo, handleFuelSelect, errors, state, handleFuelLevelInSelect } = useContext(LoanVehicleContext);

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <div className="Loan_Veh_heading">Booking Details</div>
            </Grid>
            <Grid item xs={12}>
                <Alert severity="info" icon={false} style={{ fontSize: '11px', textTransform: 'uppercase', marginBottom: '10px' }}>
                    Please Note: Fuel Must Be Returned At The Level Receive. Fuel Charges Will Apply For Any Fuel Used If Not Refilled
                </Alert>
            </Grid>
            <Hidden only={['xs', 'sm']}>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                    <InputLabel shrink component="legend" style={{ marginBottom: 8 }} required error>
                        Date Out
                    </InputLabel>
                    <DateTimePicker name="dateOut" value={bookingDetails.dateOut} onChange={handleBookingDetails} required disabled={state.isVehicleReceived} />
                    {errors.dateOut && <FormHelperText error>{errors.dateOut}</FormHelperText>}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <InputLabel shrink component="legend" required error>
                        Mileage Out
                    </InputLabel>
                    <TextBox
                        name="mileageOut"
                        value={bookingDetails.mileageOut}
                        onChange={handleBookingDetails}
                        required
                        type="number"
                        min={0}
                        disabled={state.isVehicleReceived}
                    />
                    {errors.mileageOut && <FormHelperText error>{errors.mileageOut}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <InputLabel shrink component="legend" required error>
                        Fuel Level Out
                    </InputLabel>
                    <SingelSelect onChange={(e, option) => handleFuelSelect(option)} options={state.fuelOutDrpown} value={state.selectedFuelOut} required />{' '}
                    {errors.selectedFuelOut && <FormHelperText error>{errors.selectedFuelOut}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                    <InputLabel shrink component="legend" style={{ marginBottom: 8 }}>
                        Estimated Due Date
                    </InputLabel>
                    <DateTimePicker
                        name="estimatedDateDueIn"
                        value={bookingDetails.estimatedDateDueIn}
                        onChange={handleBookingDetails}
                        required
                        minDate={bookingDetails.dateOut}
                        disabled={state.isVehicleReceived}
                    />
                </Grid>

                {/* Summary items for large screens */}
                <Hidden mdDown>
                    <Grid item md={2} lg={2} xl={2}>
                        <InputLabel shrink style={{ marginBottom: 8 }}>
                            Total Mileage covered
                        </InputLabel>
                        <BiggerDisabledText value={(bookingDetails.mileageIn && bookingDetails.mileageIn - bookingDetails.mileageOut) || ''} />
                    </Grid>
                </Hidden>

                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                    <InputLabel shrink component="legend" style={{ marginBottom: 8 }} required error>
                        Date In
                    </InputLabel>
                    <DateTimePicker
                        name="dateIn"
                        value={bookingDetails.dateIn}
                        onChange={handleBookingDetails}
                        minDate={bookingDetails.dateOut}
                        disabled={state.isVehicleReceived}
                    />
                    {errors.dateIn && <FormHelperText error>{errors.dateIn}</FormHelperText>}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <InputLabel shrink component="legend" required error>
                        Mileage In
                    </InputLabel>
                    <TextBox
                        name="mileageIn"
                        value={bookingDetails.mileageIn}
                        onChange={handleBookingDetails}
                        type="number"
                        min={bookingDetails.mileageOut || 0}
                        disabled={state.isVehicleReceived}
                    />
                    {errors.mileageIn && <FormHelperText error>{errors.mileageIn}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <InputLabel shrink component="legend" required error>
                        Fuel Level In
                    </InputLabel>
                    <SingelSelect
                        onChange={(e, option) => handleFuelLevelInSelect(option)}
                        options={state.fuelOutDrpown}
                        value={state.selectedFuelLevelFuelIn}
                        required
                    />{' '}
                    {/* <TextBox
                        name="fuelIn"
                        value={bookingDetails.fuelIn}
                        onChange={handleBookingDetails}
                        type="number"
                        min={0}
                        max={100}
                        disabled={state.isVehicleReceived}
                    /> */}
                    {errors.fuelIn && <FormHelperText error>{errors.fuelIn}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                    <Grid item xs={12}>
                        <InputLabel shrink component="legend" required error style={{ marginBottom: -6, whiteSpace: 'nowrap' }}>
                            Insurance Certificate Uploaded?
                        </InputLabel>
                    </Grid>
                    <YesNoButton
                        state={bookingDetails.loanVehicleUsageInsuranceUploaded}
                        name="loanVehicleUsageInsuranceUploaded"
                        onYesClick={() => handleYesNo('loanVehicleUsageInsuranceUploaded', true)}
                        onNoClick={() => handleYesNo('loanVehicleUsageInsuranceUploaded', false)}
                    />
                    {errors.loanVehicleUsageInsuranceUploaded && <FormHelperText error>{errors.loanVehicleUsageInsuranceUploaded}</FormHelperText>}
                </Grid>

                {/* Summary items for medium screens only */}
                <Hidden only={['xs', 'sm', 'lg', 'xl']}>
                    <Grid item xs={12} container>
                        <Grid
                            item
                            xs={6}
                            style={{
                                padding: '4px 7px',
                                display: 'flex',
                                alignItems: 'center',
                                height: '32px',
                                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                color: 'black'
                            }}
                        >
                            Total Mileage covered: <b>{(bookingDetails.mileageIn && bookingDetails.mileageIn - bookingDetails.mileageOut) || ''}</b>
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            style={{
                                padding: '4px 7px',
                                display: 'flex',
                                alignItems: 'center',
                                height: '32px',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                color: 'white'
                            }}
                        >
                            Total Fuel Used:{' '}
                            <b>
                                {bookingDetails.fuelIn != null && bookingDetails.fuelOut != null
                                    ? Math.abs(bookingDetails.fuelIn - bookingDetails.fuelOut).toFixed(2)
                                    : ''}
                            </b>
                        </Grid>
                    </Grid>
                </Hidden>

                {/* Summary item for large screens */}
                <Hidden mdDown>
                    <Grid item xs={2} lg={2} xl={2}>
                        <InputLabel shrink style={{ marginBottom: 8 }}>
                            Total Fuel Used
                        </InputLabel>
                        <BiggerDisabledText
                            value={
                                bookingDetails.fuelIn != null && bookingDetails.fuelOut != null
                                    ? Math.abs(bookingDetails.fuelIn - bookingDetails.fuelOut).toFixed(2)
                                    : ''
                            }
                        />
                    </Grid>
                </Hidden>
            </Hidden>

            {/* Mobile View */}
            <Hidden only={['md', 'lg', 'xl']}>
                <Grid item xs={12} sm={4} md={6} lg={4}>
                    <InputLabel shrink component="legend" style={{ marginBottom: 8 }} required error>
                        Date Out
                    </InputLabel>
                    <DateTimePicker name="dateOut" value={bookingDetails.dateOut} onChange={handleBookingDetails} required disabled={state.isVehicleReceived} />
                    {errors.dateOut && <FormHelperText error>{errors.dateOut}</FormHelperText>}
                </Grid>

                <Grid item xs={12} sm={4} md={6} lg={2}>
                    <InputLabel shrink component="legend" required error>
                        Mileage Out
                    </InputLabel>
                    <TextBox
                        name="mileageOut"
                        value={bookingDetails.mileageOut}
                        onChange={handleBookingDetails}
                        required
                        type="number"
                        min={0}
                        disabled={state.isVehicleReceived}
                    />
                    {errors.mileageOut && <FormHelperText error>{errors.mileageOut}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={4} md={6} lg={2}>
                    <InputLabel shrink component="legend" required error>
                        Fuel Level Out
                    </InputLabel>
                    <SingelSelect onChange={(e, option) => handleFuelSelect(option)} options={state.fuelOutDrpown} value={state.selectedFuelOut} required />{' '}
                    {errors.selectedFuelOut && <FormHelperText error>{errors.selectedFuelOut}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={4} md={6} lg={4}>
                    <InputLabel shrink component="legend" style={{ marginBottom: 8 }} required error>
                        Date In
                    </InputLabel>
                    <DateTimePicker
                        name="dateIn"
                        value={bookingDetails.dateIn}
                        onChange={handleBookingDetails}
                        minDate={bookingDetails.dateOut}
                        disabled={state.isVehicleReceived}
                    />
                    {errors.dateIn && <FormHelperText error>{errors.dateIn}</FormHelperText>}
                </Grid>

                <Grid item xs={12} sm={4} md={6} lg={2}>
                    <InputLabel shrink component="legend" required error>
                        Mileage In
                    </InputLabel>
                    <TextBox
                        name="mileageIn"
                        value={bookingDetails.mileageIn}
                        onChange={handleBookingDetails}
                        type="number"
                        min={bookingDetails.mileageOut || 0}
                        disabled={state.isVehicleReceived}
                    />
                    {errors.mileageIn && <FormHelperText error>{errors.mileageIn}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={4} md={6} lg={2}>
                    <InputLabel shrink component="legend" required error>
                        Fuel Level In
                    </InputLabel>
                    <TextBox
                        name="fuelIn"
                        value={bookingDetails.fuelIn}
                        onChange={handleBookingDetails}
                        type="number"
                        min={0}
                        max={100}
                        disabled={state.isVehicleReceived}
                    />
                    {errors.fuelIn && <FormHelperText error>{errors.fuelIn}</FormHelperText>}
                </Grid>
                <Grid item xs={12} sm={4} md={6} lg={4}>
                    <InputLabel shrink component="legend" style={{ marginBottom: 8 }}>
                        Estimated Due Date
                    </InputLabel>
                    <DateTimePicker
                        name="estimatedDateDueIn"
                        value={bookingDetails.estimatedDateDueIn}
                        onChange={handleBookingDetails}
                        required
                        minDate={bookingDetails.dateOut}
                        disabled={state.isVehicleReceived}
                    />
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Grid item xs={12}>
                        <InputLabel shrink component="legend" required error style={{ marginBottom: -6 }}>
                            Insurance Certificate Uploaded?
                        </InputLabel>
                    </Grid>
                    <YesNoButton
                        state={bookingDetails.loanVehicleUsageInsuranceUploaded}
                        name="loanVehicleUsageInsuranceUploaded"
                        onYesClick={() => handleYesNo('loanVehicleUsageInsuranceUploaded', true)}
                        onNoClick={() => handleYesNo('loanVehicleUsageInsuranceUploaded', false)}
                    />
                    {errors.loanVehicleUsageInsuranceUploaded && <FormHelperText error>{errors.loanVehicleUsageInsuranceUploaded}</FormHelperText>}
                </Grid>
                <Grid item xs={12} container>
                    <Grid
                        item
                        xs={6}
                        style={{
                            padding: '4px 7px',
                            display: 'flex',
                            alignItems: 'center',
                            height: '32px',
                            backgroundColor: 'rgba(0, 0, 0, 0.1)',
                            color: 'black'
                        }}
                    >
                        Total Mileage covered: <b>{(bookingDetails.mileageIn && bookingDetails.mileageIn - bookingDetails.mileageOut) || ''}</b>
                    </Grid>
                    <Grid
                        item
                        xs={6}
                        style={{
                            padding: '4px 7px',
                            display: 'flex',
                            alignItems: 'center',
                            height: '32px',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            color: 'white'
                        }}
                    >
                        Total Fuel Used:{' '}
                        <b>
                            {bookingDetails.fuelIn != null && bookingDetails.fuelOut != null
                                ? Math.abs(bookingDetails.fuelIn - bookingDetails.fuelOut).toFixed(2)
                                : ''}
                        </b>
                    </Grid>
                </Grid>
            </Hidden>
        </Grid>
    );
};

export default BookingDetails;
